// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Wekh","productName":"Table_productName__3ZlST"};